module.exports = __webpack_public_path__ + "img/bb7.5ef7b1e1.jpg";